export function closeModal() {
    return {
        type: 'CLOSE_MODAL'
    };
}

export function openModal(modalType, props = {}) {
    return {
        type: 'OPEN_MODAL',
        modalType,
        props
    };
}


// WEBPACK FOOTER //
// ./app/actions/ModalActions.js